export default __webpack_public_path__ + "static/media/OTHER_REMIX.86090ebf.svg";